import { CreditPlan } from "../types";


interface MonthlyPurchaseSettingsProps {
  plans: CreditPlan[];
  isMonthlyPurchaseEnabled: boolean;
  isMonthlyPurchaseSaved: boolean;
  monthlyPurchaseCreditPlanId: number;
  isSaving: boolean;
  purchaseMode: "auto" | "monthly" | null;
  handleTogglePurchaseMode: (mode: "auto" | "monthly") => void;
  handleMonthlyPurchaseChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleSaveMonthlyPurchase: () => void;
  handleEditMonthlyPurchase: () => void;
}

const MonthlyPurchaseSettings = ({
  plans,
  isMonthlyPurchaseEnabled,
  isMonthlyPurchaseSaved,
  monthlyPurchaseCreditPlanId,
  isSaving,
  purchaseMode,
  handleTogglePurchaseMode,
  handleMonthlyPurchaseChange,
  handleSaveMonthlyPurchase,
  handleEditMonthlyPurchase,
}: MonthlyPurchaseSettingsProps) => {
  return (
    <div className="flex flex-col mt-6 border border-[#DCE9F3] rounded-xl">
      {!isMonthlyPurchaseSaved && (
        <div className="items-start gap-4 transition-all duration-600 ease-in-out m-3">
          <div className="flex justify-between items-center">
            <p className="font-medium text-sm leading-8 text-[#262626]">
              Enable Monthly-purchase
            </p>
            <button
              onClick={() => handleTogglePurchaseMode("monthly")}
              disabled={isSaving}
              className={`relative w-[42px] h-[24px] rounded-full transition-colors duration-600 disabled:opacity-60 disabled:cursor-not-allowed ${
                purchaseMode === "monthly" ? 'bg-[#FFD700]' : 'bg-[#DCE9F3]'
              }`}
            >
              <div
                className={`absolute top-[3px] w-[18px] h-[18px] rounded-full bg-white   border-2 ${
                  purchaseMode === "monthly" ? 'left-[21px]' : 'left-[3px]'
                } transition-all duration-600 `}
              ></div>
            </button>
          </div>
          <div className="opacity-100 transition-opacity duration-600 ease-in-out">
            <p className="text-xs leading-[19plugpx] text-[#737C8C] mt-1 max-w-md">
              Automatically purchase the selected amount of tokens at the start of the month. Your most recent payment method will be used.
            </p>
          </div>
          {isMonthlyPurchaseEnabled && (
            <div className="mt-2 p-1 space-y-2 w-full transition-all duration-600 ease-in-out transform opacity-100 translate-y-0">
              <div className="flex m-2 gap-6">
                <div className="flex flex-col gap-2 w-1/2">
                  <label className="text-sm text-[#262626]">Purchase Token Count</label>
                  <div className="flex items-center bg-[#F5F9FE] rounded-md h-[50px] pr-5 gap-5">
                    <div className="w-[45px] h-[50px] flex items-center justify-center bg-[#E7F0FA] icon-prefix">
                      <img className="w-3 my-4" src="/images/dollar.svg" alt="$" />
                    </div>
                    <select
                      className="w-full bg-transparent text-sm border-none  cursor-pointer"
                      value={monthlyPurchaseCreditPlanId}
                      onChange={handleMonthlyPurchaseChange}
                    >
                      {plans.map((plan) => (
                        <option key={plan.id} value={plan.id}>
                          {plan.creditNumber} Tokens
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <button
                className="w-full h-[45px] border border-[#FFD700] rounded-md text-[#FFD700] font-semibold text-base leading-8 transition-all duration-600 hover:bg-[#FFD700] hover:text-white"
                onClick={handleSaveMonthlyPurchase}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          )}
        </div>
      )}
      {isMonthlyPurchaseSaved && (
        <div className="relative w-full transition-all duration-600 ease-in-out transform opacity-100 translate-y-0">
          <div className="bg-[#F5F9FE] rounded-xl w-full h-16">
            <div className="flex flex-row items-center justify-between px-4 py-3 gap-4">
              <div className="flex flex-row items-center gap-2">
                <svg
                  className="w-[18.45px] h-[18.45px] text-[#44CA51]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20 6L9 17l-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <p className="font-['Poppins'] text-sm text-[#262626] leading-5">
                  Monthly-purchase is now active
                </p>
              </div>
              <button
                className="flex items-center px-[10px] gap-[7px] border border-[#304CB2]/10 rounded-md w-[64px] h-[32px] transition-all duration-900 hover:bg-[#304CB2]/10"
                onClick={handleEditMonthlyPurchase}
              >
                <svg
                  className="w-[11px] h-[11px] text-[#304CB2]"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                </svg>
                <span className="font-['Poppins'] font-medium text-sm text-[#304CB2] leading-5">
                  Edit
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthlyPurchaseSettings;